'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  ', ': calc(100% + 10px);\n  transform: translateY(-50%);\n'], ['\n  position: absolute;\n  top: 50%;\n  ', ': calc(100% + 10px);\n  transform: translateY(-50%);\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Check = _styledComponents2.default.div(_templateObject, function (_ref) {
  var left = _ref.left;
  return left ? 'right' : 'left';
});

exports.default = Check;